/**
 * Created by Tai on 6/17/2020.
 */
import {Component, AfterViewInit, ElementRef, HostBinding, ViewChild} from '@angular/core';
import {MatLegacyDialog as MatDialog} from '@angular/material/legacy-dialog';
import {AdminApi, Company} from '../admin-api';
import {AppLoaderComponent} from '../../shared/app-loader/app-loader.component';
import {PaginatorComponent} from '../../shared/paginator/paginator.component';
import {RestDataSource} from '../../shared/rest-data-source';
import {MatSort} from '@angular/material/sort';
import {Router} from '@angular/router';
import {Path} from 'app/shared/path';
import {RegisterCompanyDialogComponent} from '../../account/register-company-dialog/register-company-dialog.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
   selector: 'app-company-list',
   templateUrl: './company-list.component.html',
   styleUrls: ['./company-list.component.css']
})
export class CompanyListComponent implements AfterViewInit {

   @HostBinding('class') get className() {
      return 'app-company-list';
   }

   @ViewChild(PaginatorComponent) paginator: PaginatorComponent;
   @ViewChild(MatSort) sort: MatSort;
   @ViewChild(AppLoaderComponent) loader: AppLoaderComponent;
   @ViewChild('wrapper') wrapper: ElementRef;
   displayedColumns = ['no', 'name', 'tin', 'created_by', 'cellphone_num', 'creation_date', 'approval_date', 'register'];
   dataSource = new RestDataSource<Company>();
   error: string;

   constructor(private api: AdminApi, public dialog: MatDialog, private router: Router, public translate: TranslateService) {
   }

   ngAfterViewInit() {
      this.getData();
      localStorage.removeItem('admin-tool');
   }

   getData() {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.changes.subscribe((params: any) => {
         this.loader.show();
         this.api.listCompany(params)
            .subscribe(data => {
               this.dataSource.loaded(data);
               this.loader.hide();
               this.wrapper.nativeElement.scrollTop = 0;
            }, e => {
               this.error = e.message;
               this.loader.hide();
            });
      });
      setTimeout(() => this.dataSource.loadData());
   }

   highlight(row) {
      this.adminMenu(row);
   }

   adminMenu(item: any) {
      const url = Path.combine('/admin-tool/company-profile', encodeURIComponent(item.name));
      this.router.navigate([url]);
   }

   openRegisterCompany(): void {
      const etaxInvoice = this.dialog.open(RegisterCompanyDialogComponent, {
         disableClose: true,
         data: {isCreateByAdmin: true}
      });
      etaxInvoice.afterClosed().subscribe(result => {
         if (result) {
            this.getData();
         }
      });
      this.translate.get('register_dashboard_company').subscribe((msg) => {
         etaxInvoice.componentInstance.title = msg;
      });
   }

}
